'use client';

import type { ReactNode } from 'react';

export const DebugLinkLogger = ({ children }: { children: ReactNode }) => {
  const handleClick = () => {
    const cookies = document.cookie.split(';');
    const utpCookie = cookies.find(c => c.trim().startsWith('__utp='));
    const utpValue = utpCookie?.split('=').slice(1).join('=');

    let pianoUid = 'unknown';
    if (utpValue) {
      try {
        const base64Url = utpValue.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        pianoUid = payload.sub ?? 'unknown';
      } catch {
        pianoUid = 'decode_failed';
      }
    }

    navigator.sendBeacon('/api/debugLog', JSON.stringify({
      flag: '[getIsLoggedIn pre-request]',
      pianoUid,
      utpLength: utpValue?.length ?? null,
      dotCount: utpValue?.split('.').length ?? 0,
      totalCookieHeaderLength: document.cookie.length,
    }));
  };

  return (
    <div onClick={handleClick}>
      {children}
    </div>
  );
};
